import SportsList from './SportsList';

const InPlaySportSidebar = () => <SportsList basePath='/sports' />;

export default InPlaySportSidebar;
